import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DisciplineService } from 'src/app/services/discipline.service';
import { MediaService } from 'src/app/services/media.service';
import { PageService } from 'src/app/services/page.service';
import { SpecialisatieService } from 'src/app/services/specialisatie.service';

@Component({
  selector: 'app-discipline',
  templateUrl: './discipline.component.html',
  styleUrls: ['./discipline.component.sass']
})
export class DisciplineComponent implements OnInit {

  discid:any;
  disc:any;
  specs:any = [];

  constructor(
    private specService:SpecialisatieService,
    private discService:DisciplineService,
    private mediaService:MediaService,
    private activatedRoute: ActivatedRoute,
    private pageService: PageService) { }

  ngOnInit(): void {
    // Check query params
    let params = this.activatedRoute.snapshot.queryParams;

    if(!params) return;
    this.discid = params["discid"];

    this.discService.getDiscipline(this.discid).subscribe(data => {
      this.disc = this.discService.populateDiscipline(data.data[0]);
      this.pageService.setCurrentHeader(this.disc.banner_image);
    });

    this.specService.getSpecialisatiesFor(this.discid).subscribe(data => {
      data.data.forEach((element:any) => {
        this.specs.push(this.specService.populateSpecialisatie(element));
      });
    });
  }

}
